module.exports = __webpack_public_path__ + "img/button_to_button_back.b7cbf755.png";